export type RegexLogic = 
  | RegExp
  | string
  | { and: (RegexLogic | string)[] }
  | { or: (RegexLogic | string)[] }
  | { not: RegexLogic };

export class ReTree {
  constructor() {}

  /**
   * Tests if the given string matches the provided regex logic.
   * @param str - The input string to test against.
   * @param regex - The regex or logic-based object to test.
   * @returns A boolean indicating if the string matches.
   */
  public test(str: string, regex: RegexLogic): boolean {
    if (typeof regex === "string") {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.test(str);
    } else if (regex && "and" in regex) {
      return regex.and.every((item) => this.test(str, item));
    } else if (regex && "or" in regex) {
      return regex.or.some((item) => this.test(str, item));
    } else if (regex && "not" in regex) {
      return !this.test(str, regex.not);
    } else {
      return false;
    }
  }

  /**
   * Executes the provided regex logic on the given string.
   * @param str - The input string to execute the regex on.
   * @param regex - The regex or logic-based object to execute.
   * @returns The match result or `null` if no match is found.
   */
  public exec(str: string, regex: RegexLogic): RegExpExecArray | null {
    if (typeof regex === "string") {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.exec(str);
    } else if (Array.isArray(regex)) {
      return regex.reduce<RegExpExecArray | null>(
        (res, item) => res || this.exec(str, item),
        null
      );
    } else {
      return null;
    }
  }
}
